// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Edit2 } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconEdit2(props: any) {
    return <IconBase icon={Edit2} {...props} />
  }

  export default IconEdit2
  